export const DASHBOARD = 'DASHBOARD';
export const BOOKING = 'BOOKING';
export const ACCOUNT = 'ACCOUNT';
export const HELP = 'HELP';
export const AUTH = 'AUTH';
export const LANDING = 'LANDING';